import React from "react";
import {
    Space,
    Row,
    Col,
    message,
    Image,
    Button,
    Modal,
    Tooltip,
    Drawer,
    Input,
    Tabs,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import { Link } from "react-router-dom";
import { CloseOutlined } from "@ant-design/icons";

import withRouter from "../withRouter";
import InspectionStore from "../store/InspectionStore";
import ListTable from "./ListTable";
import CompanyAutocomplete from "./CompanyAutocomplete";
import CompanyStore from "../store/CompanyStore";
import InspectionAdd from "./InspectionAdd";
import editIcon from "../assets/images/NewDesign/pencil-square.svg";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import TicketAdd from "./TicketAdd";
import kebabIcon from "../assets/images/NewDesign/kebab.svg";

const listData = [
    {
        "ticketId": "TK-1024",
        "subject": "Vehicle not updating location",
        "category": "Tracking Issue",
        "priority": "Low",
        "status": "Open",
        "raisedBy": "Ahmed",
        "raisedOn": "2026/05/16 10:30 AM",
        "lastUpdated": "2026/05/17 11:33 AM",
        "comments": 24,
        "attachments": 63,
        "tag": "text"
    },
    {
        "ticketId": "TK-1023",
        "subject": "Incorrect ETA shown",
        "category": "ETA / Delay",
        "priority": "Low",
        "status": "In Progress",
        "raisedBy": "Sharique",
        "raisedOn": "2026/05/15 04:15 PM",
        "lastUpdated": "2026/05/16 06:10:59",
        "comments": 0,
        "attachments": 0
    },
    {
        "ticketId": "TK-1022",
        "subject": "Webhook not receiving data",
        "category": "Integration",
        "priority": "Medium",
        "status": "Open",
        "raisedBy": "Imran",
        "raisedOn": "2026/05/15 10:30 AM",
        "lastUpdated": "2026/05/16 06:10:59",
        "comments": 0,
        "attachments": 0
    },
    {
        "ticketId": "TK-1021",
        "subject": "Delay in shipment pickup",
        "category": "Operations",
        "priority": "High",
        "status": "On Hold",
        "raisedBy": "Ahmed",
        "raisedOn": "2026/05/14 10:30 AM",
        "lastUpdated": "2026/05/15 06:10:59",
        "comments": 0,
        "attachments": 0
    },
    {
        "ticketId": "TK-1020",
        "subject": "Unable to download POD",
        "category": "Document",
        "priority": "High",
        "status": "Resolved",
        "raisedBy": "Furqan",
        "raisedOn": "2026/05/14 10:30 AM",
        "lastUpdated": "2026/05/15 06:10:59",
        "comments": 0,
        "attachments": 0
    },
    {
        "ticketId": "TK-1019",
        "subject": "Delay in shipment pickup",
        "category": "Operations",
        "priority": "Medium",
        "status": "Closed",
        "raisedBy": "Rahil",
        "raisedOn": "2026/05/13 10:30 AM",
        "lastUpdated": "2026/05/14 06:10:59",
        "comments": 0,
        "attachments": 0
    }
]

const getFilteredData = (status) => {
    if (status === "All") {
        return listData;
    }

    return listData.filter((item) => item.status === status);
};
class TicketList extends React.Component {
    constructor(props, context) {
        super(props);

        this.handleTableChange = this.handleTableChange.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.inspectionStore = new InspectionStore();
        this.companyStore = new CompanyStore();

        this.state = {
            loading: false,
            pageSize: 50,
            currentPage: 1,
            companyVal_Lab: "",
            openInspectionForm: false,
            inspectionId: "",
            listDataUpdate: false,
            openDeleteModal: false,
            deleteData: {},
            editData: {},
            openTicketForm: false,
        };

        this.columns = [
            {
                title: context.translate("_TICKET_ID_"),
                dataIndex: "ticketId",
                width: 15,
                ellipsis: {
                    showTitle: true,
                },
            },
            {
                title: context.translate("_SUBJECT_"),
                dataIndex: "subject",
                width: 15,
                ellipsis: {
                    showTitle: true,
                },
            },
            {
                title: context.translate("_CATEGORY_"),
                dataIndex: "category",
                width: 15,
                ellipsis: {
                    showTitle: true,
                },
            },
            {
                title: context.translate("_PRIORITY_"),
                dataIndex: "priority",
                width: 15,
                ellipsis: {
                    showTitle: true,
                },
                render: (value) => {

                    if (value === "Low") {
                        return <div className="ticketList-priority-type-low">{value}</div>;
                    } else if (value === "Medium") {
                        return <div className="ticketList-priority-type-medium">{value}</div>;
                    } else if (value === "High") {
                        return <div className="ticketList-priority-type-high">{value}</div>;
                    }
                }

            },
            {
                title: context.translate("_STATUS_"),
                dataIndex: "status",
                width: 15,
                ellipsis: {
                    showTitle: true,
                },
                render: (value) => {
                    if (value === "Open") {
                        return <div className="ticketList-status-type-open">{value}</div>;
                    } else if (value === "In Progress") {
                        return <div className="ticketList-status-type-inProgress">{value}</div>;
                    } else if (value === "On Hold") {
                        return <div className="ticketList-status-type-onHold">{value}</div>;
                    } else if (value === "Resolved") {
                        return <div className="ticketList-status-type-resolved">{value}</div>;
                    } else if (value === "Closed") {
                        return <div className="ticketList-status-type-closed">{value}</div>;
                    }
                }
            },
            {
                title: context.translate("_RAISED_BY_"),
                dataIndex: "raisedBy",
                width: 15,
                ellipsis: {
                    showTitle: true,
                },
            },
            {
                title: context.translate("_RAISED_ON_"),
                dataIndex: "raisedOn",
                width: 15,
                ellipsis: {
                    showTitle: true,
                },
            },
            {
                title: context.translate("_LAST_UPDATED_"),
                dataIndex: "lastUpdated",
                width: 15,
                ellipsis: {
                    showTitle: true,
                },
            },
            {
                // title: "Action",
                title: context.translate("_ACTION_"),
                dataIndex: "groupname",
                ellipsis: {
                    showTitle: true,
                },
                align: "center",
                width: 5,
                render: (_, record) => {
                    return (
                        <>
                            <Image
                                style={{ cursor: "pointer", width: "6px" }}
                                src={kebabIcon}
                                onClick={(e) => {
                                    e.preventDefault();
                                }}
                            ></Image>
                        </>
                    );
                },
            },
        ];

        this.tabItems = [
            {
                key: '1',
                label: 'All Tickets',
                children: (
                    <ListTable
                        columns={this.columns}
                        dataSource={getFilteredData("All")}
                        ticketListcls="ticketListcls"
                    />

                )
            },
            {
                key: '2',
                label: 'Open',
                children: (
                    <ListTable
                        columns={this.columns}
                        dataSource={getFilteredData("Open")}
                    />
                ),
            },
            {
                key: '3',
                label: 'In Progress',
                children: (
                    <ListTable
                        columns={this.columns}
                        dataSource={getFilteredData("In Progress")}
                    />
                ),

            },
            {
                key: '4',
                label: 'On Hold',
                children: (
                    <ListTable
                        columns={this.columns}
                        dataSource={getFilteredData("On Hold")}
                    />
                ),
            },
            {
                key: '5',
                label: 'Resolved',
                children: (
                    <ListTable
                        columns={this.columns}
                        dataSource={getFilteredData("Resolved")}
                    />
                ),
            },
            {
                key: '6',
                label: 'Closed',
                children: (
                    <ListTable
                        columns={this.columns}
                        dataSource={getFilteredData("Closed")}
                    />
                ),
            },
        ];
    }

    async componentDidMount() {
        if (
            Number(this.props.getUserData().isadmin) !== -1 &&
            Number(this.props.getUserData().isadmin) !== 3
        ) {
            await this.setState({
                companyId: this.props.getUserData().userCompanyId,
            });
            await this.setState({ userId: this.props.getUserData().userId });
            await this.handleSearch();
        }
        this.setState({ pageSize: 50 });
    }

    async componentDidUpdate(prevProps, prevState) {
        if (Number(this.props.getUserData().isadmin) === 0) {
            this.props.navigate("/login");
        }
        if (prevState.listDataUpdate !== this.state.listDataUpdate) {
            const setInspectionStates =
                this.context.viewStateStore.inspectionListObject;

            await this.inspectionStore.loadData({
                offset: (this.state.currentPage - 1) * this.state.pageSize,
                limit: this.state.pageSize,

                companyId: setInspectionStates.companyId,
            });
            const singleData = await this.companyStore.getCompanyDataById(
                setInspectionStates.companyId
            );

            await this.setState({ loadList: 1 });

            await this.setState({
                companyVal_Lab: singleData,
                companyId: setInspectionStates.companyId,
            });

            await this.setState({ listDataUpdate: false });
        }
    }
    async handleTableChange(pagination, filters, sorter) {
        await this.setState({
            currentPage: pagination.current,
            pageSize: pagination.pageSize,
        });
        await this.handleSearch();
    }
    async handleChange(comp) {
        await this.setState({
            companyId: comp.value,
            companyLoading: true,
            currentPage: 1,
            pageSize: 50,
        });
        const singleData = await this.companyStore.getCompanyDataById(comp.value);
        await this.setState({ companyVal_Lab: singleData });
        // await this.setState({ companyId: comp.value });
        await this.handleSearch();
    }

    async handleSearch() {
        await this.inspectionStore.loadData({
            offset: (this.state.currentPage - 1) * this.state.pageSize,
            limit: this.state.pageSize,
            // warehouseId:this.state.warehouseId,
            companyId: this.state.companyId,
        });
        await this.setState({ loadList: 1 });
    }

    onEdit = async (record) => {
        const inspectionId = record.ins_Id;
        if (inspectionId) {
            this.context.viewStateStore.setInspectionStates({
                companyId: record.companyId,
            });
            // this.props.navigate("/inspectionadd/" + inspectionId);
        }
        await this.setState({ inspectionId: record.ins_Id });
        await this.setState({ openInspectionForm: true });
    };

    onDelete = async (record) => {
        const response = await this.inspectionStore.deleteRecord({
            ins_Id: record.ins_Id,
            companyId: record.companyId,
        });

        if (response?.data?.success === "S") {
            message.success(response.data.message);
            this.setState({ openDeleteModal: false });
            this.handleSearch();
        } else {
            message.error(response.data.message);
        }
    };

    responseMsg = async (resp) => {
        if (resp.success == "S") {
            message.success(resp.message);
            await this.setState({ openTicketForm: false });
            await this.setState({ listDataUpdate: true });

            //  await this.handleSearch();
            // this.props.navigate("/companyuserlist");
        } else {
            message.error(resp.message);
        }
    };

    closeModal = () => {
        this.setState({ openTicketForm: false, ticketId: "" });
    };

    refreshList = async () => {
        this.setState({ loading: true });
        // await this.inspectionStore.loadData({
        //     offset: 0,
        //     limit: 50,
        //     companyId: this.state.companyId,
        // });
        this.setState({ loading: false, currentPage: 1 });
    };

    onTabChange = async (key) => {
        console.log(key);
    }
    render() {
        return (
            <>
                <div className="listHeader">
                    <Row className="listInputRow">
                        <Col span={16}>
                            <Space>
                                <Input placeholder={"Search"} style={{ borderRadius: "40px", width: "250px" }} />
                            </Space>
                        </Col>
                        <Col
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "end",
                            }}
                            span={8}
                        >
                            <Tooltip
                                title={this.context.translate("_REFRESH_")}
                                placement="bottom"
                            >
                                <Image
                                    style={{
                                        height: 18,
                                        marginInlineEnd: "20px",
                                        alignItems: "center",
                                        cursor: "pointer",
                                    }}
                                    src={refreshIcon}
                                    onClick={() => this.refreshList()}
                                ></Image>
                            </Tooltip>

                            <Button
                                className="addButtonClass"
                                onClick={() =>
                                    this.setState({ openTicketForm: true, ticketId: "" })
                                }
                            >
                                <Image
                                    style={{ width: 13, marginInlineEnd: "5px" }} //marginInlineEnd: "5px",
                                    src={require("../assets/images/NewDesign/plus (Stroke).png")}
                                ></Image>
                                {this.context.translate("_FLEET_DRIVER_DRIVERLIST_ADDBTN_")}
                            </Button>
                        </Col>
                    </Row>
                    <Tabs className="ticketTabs" defaultActiveKey="1" items={this.tabItems} onChange={this.onTabChange} />



                </div>

                {this.state.openTicketForm && (

                    <Drawer
                        className="uploadExcelDrawer"
                        width={716}
                        closeIcon={false}
                        open={this.state.openTicketForm}
                        footer={false}
                        placement={

                            this.context.locale.language === "arabic" ? "left" : "right"

                        }
                        title={
                            <div className="formTitle">
                                {this.context.translate("_TICKET_DETAILS_")}
                                <p className="formDescription">
                                    {this.context.translate("_TICKET_DETAILS_DESC_")}
                                </p>
                            </div>
                        }
                        maskClosable={false}
                        onOk={() => this.setState({ openTicketForm: false })}
                        onCancel={() =>
                            this.setState({ openTicketForm: false, ticketId: "" })
                        }
                    >
                        <div style={{ height: "100%" }}>
                            <TicketAdd
                                userId={this.state.ticketId}
                                response={this.responseMsg}
                                closeModal={this.closeModal}
                            />
                        </div>
                    </Drawer>
                )}
                {this.state.openDeleteModal && (
                    <Modal
                        maskClosable={false}
                        title={
                            <div className="deleteModalTitle">
                                <span>
                                    {" "}
                                    {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
                                </span>
                                <CloseOutlined
                                    style={{ cursor: "pointer", color: "white" }}
                                    onClick={() => this.setState({ openDeleteModal: false })}
                                />
                            </div>
                        }
                        className="deleteModal"
                        description="Are you sure you want to delete this Item? This action cannot be undone."
                        centered
                        open={this.state.openDeleteModal}
                        footer={null}
                        width={400}
                        closable={false}
                    >
                        <div className="deleteModalText">
                            <p>{this.context.translate("_DELETE_STATUS_")}</p>
                        </div>
                        <div className="deleteModalButtons">
                            <Button
                                className="deleteModalCancelButton"
                                onClick={() => this.setState({ openDeleteModal: false })}
                            >
                                {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
                            </Button>

                            <Button
                                className="deleteModalOkButton"
                                onClick={() => this.onDelete(this.state.deleteData)}
                            >
                                {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
                            </Button>
                        </div>
                    </Modal>
                )}
            </>
        );
    }
}
TicketList.contextType = StoreContext;
export default observer(withRouter(TicketList));
